import { Component, OnDestroy, OnInit } from "@angular/core";
import { FREQUENCIES } from "app/_constants/frequencies";
import { MESSAGE_OVERVIEW_TYPES } from "app/_constants/messageOverview";

@Component({
    selector: "app-messages-overview",
    templateUrl: "./messages-overview.component.html",
    
  })
  export class MessagesOverviewComponent {

    frequesncies = FREQUENCIES;
    constructor(
      ) { 

      } 
  }